import { useFormState } from "common/hooks";

import { PasswordChangeFormValues } from "client/accounts/types";
import PasswordInput from "client/common/components/inputs/PasswordInput";
import DrawerLayout from "client/common/components/stackables/DrawerLayout";
import { useCurrentDrawer } from "client/common/hooks/stackables";

import { passwordConditions } from "../../utils";
import { useUpdatePasswordMutation } from "../../hooks";

const AccountUpdatePasswordDrawer = () => {
  const { close } = useCurrentDrawer();
  const [values, updateField] = useFormState<PasswordChangeFormValues>({
    old_password: "",
    new_password: "",
  });
  const canSubmit =
    passwordConditions.every(({ check }) => check(values.new_password)) &&
    !!(values.old_password && values.new_password);

  const {
    mutate: updatePassword,
    isLoading: isUpdateLoading,
    error: updateError,
  } = useUpdatePasswordMutation({ onSuccess: close });

  return (
    <DrawerLayout>
      <DrawerLayout.Header title="Update password" onClose={close} />
      <DrawerLayout.Form
        submitText="Update Password"
        canSubmit={canSubmit}
        onSubmit={() => updatePassword(values)}
        isLoading={isUpdateLoading}
        error={updateError}
      >
        <DrawerLayout.Form.Group>
          <PasswordInput
            value={values.old_password}
            onChange={updateField("old_password")}
            label="Old Password"
            passwordConditions={[]}
            errors={updateError?.errors.old_password}
          />
        </DrawerLayout.Form.Group>
        <DrawerLayout.Form.Group>
          <PasswordInput
            value={values.new_password}
            onChange={updateField("new_password")}
            label="New Password"
            passwordConditions={passwordConditions}
            errors={updateError?.errors.new_password}
          />
        </DrawerLayout.Form.Group>
      </DrawerLayout.Form>
    </DrawerLayout>
  );
};

export default AccountUpdatePasswordDrawer;
